module.exports = __webpack_public_path__ + "img/mock_test.d39bb613.svg";